import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { KmkMBCacheViewModel } from './kmkMBCacheViewModel';

export class KmkMBCacheContainer extends MasterDataContainer<KmkMBCacheViewModel> {
    constructor(models: Array<KmkMBCacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
